<template>
  <div class="hello" id="container">
    <div class="container">
      <div v-if="success">{{ $t('survey.success1') }}<br />{{ $t('survey.success2') }}</div>
      <div v-if="!success">
        <div v-if="error" class="alert warning" role="alert">
          <div class="icon"></div>
          <div class="message">{{ $t('survey.error') }}</div>
        </div>
        <section id="rating-form" class="section">
          <label for="ticket_satisfaction_rating">{{ $t('survey.rateCta') }}</label>

          <div id="satisfaction-rating-buttons">
            <input id="satisfaction_rating_good" name="satisfaction_rating" type="radio" value="Good" v-model="rating" />
            <label for="satisfaction_rating_good">
              <div class="btn rating good">
                <span class="icon"></span>
                <span class="long">
                  {{ $t('survey.ratingGoodLong') }}
                </span>
                <span class="short">
                  {{ $t('survey.ratingGoodShort') }}
                </span>
              </div>
            </label>
            <input id="satisfaction_rating_bad" name="satisfaction_rating" type="radio" value="Bad" v-model="rating" />
            <label for="satisfaction_rating_bad">
              <div class="btn rating bad">
                <span class="icon"></span>
                <span class="long">
                  {{ $t('survey.ratingBadLong') }}
                </span>
                <span class="short">
                  {{ $t('survey.ratingBadShort') }}
                </span>
              </div>
            </label>
          </div>

          <label for="ticket_satisfaction_comment">{{ $t('survey.commentCta') }}</label>
          <textarea rows="6" name="ticket[satisfaction_comment]" id="ticket_satisfaction_comment" v-model="comment"></textarea>

          <div id="rating-form-actions">
            <button name="button" type="submit" class="btn btn-primary submit" v-on:click="submitSurvey" :disabled="isBusy">{{ $t('survey.submitButtonText') }}</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { csbpApi } from '@/config/index.js';
export default {
  name: 'Survey',
  props: {
    siteName: String,
    ticketId: String,
    language: String,
    requesterId: String,
    survey: Boolean,
    initialRating: String,
  },
  data: () => ({
    comment: '',
    error: false,
    isBusy: false,
    success: false,
    rating: 'Good',
  }),

  async mounted() {
    window.addEventListener('resize', this.resizeWindow);
    this.resizeWindow();
    this.$i18n.locale = this.language || 'en-us';
    this.rating = this.initialRating;
  },
  methods: {
    resizeWindow() {
      let newHeight = document.getElementById('hello') && document.getElementById('hello').scrollHeight ? `${Math.max(document.getElementById('hello').scrollHeight, 250)}px` : '600px';
      if (window.parent) {
        window.parent.postMessage({ height: newHeight }, '*');
      }
    },
    async submitSurvey() {
      if (!this.ticketId || !this.requesterId || !this.survey) {
        throw new Error('Invalid request');
      }
      try {
        this.isBusy = true;
        let response = await axios.post(
          `${csbpApi}/zendesk/ticket/${this.ticketId}/survey`,
          {
            requesterId: this.requesterId,
            rating: this.rating,
            comment: this.comment,
          },
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (response.data.data.type !== 'SurveyAccepted') {
          throw new Error('Something went wrong');
        }
        this.success = true;
      } catch (error) {
        console.error(error);
        this.error = true;
        const that = this;
        setTimeout(() => {
          that.error = false;
        }, 3000);
        return;
      } finally {
        this.isBusy = false;
        this.resizeWindow();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background-color: #f7f4f4;
}

/*! normalize.css v3.0.2 | MIT License | git.io/normalize */

html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}

audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
}

a:active,
a:hover {
  outline: 0;
}

abbr[title] {
  border-bottom: 1px dotted;
}

b,
strong {
  font-weight: bold;
}

dfn {
  font-style: italic;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

mark {
  background: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sup {
  top: -0.5em;
}

sub {
  bottom: -0.25em;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

figure {
  margin: 1em 40px;
}

hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}

pre {
  overflow: auto;
}

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html input[type='button'],
input[type='reset'],
input[type='submit'] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input {
  line-height: normal;
}

input[type='checkbox'],
input[type='radio'] {
  box-sizing: border-box;
  padding: 0;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  height: auto;
}

input[type='search'] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}

fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  border: 0;
  padding: 0;
}

textarea {
  overflow: auto;
}

optgroup {
  font-weight: bold;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}

* html .clearfix {
  zoom: 1;
}

*:first-child + html .clearfix {
  zoom: 1;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

html {
  font-size: 10px;
}

@media only screen and (max-width: 500px) {
  html {
    font-size: 13px;
  }
}

body {
  min-width: 320px;
  background: #f8f9f9;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Arial, sans-serif;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
  color: #2f3941;
}

.btn {
  display: inline-block;
  padding: 0.8rem 1.3rem;
  margin-bottom: 0;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
  color: #2f3941;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #d8dcde;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  border-radius: 4px;
  white-space: nowrap;
}

.btn:focus,
.btn:active,
.btn:focus:active,
.btn:active:focus {
  outline: 0;
}

.btn:focus {
  box-shadow: 0 0 0 3px rgba(47, 57, 65, 0.35) !important;
}

.btn:hover {
  background-color: #f8f9f9;
  border-color: #c2c8cc;
  color: #2f3941;
}

.btn:active,
.btn.active {
  background-color: #f8f9f9;
  border-color: #c2c8cc;
  color: #2f3941;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.btn.disabled,
.btn[disabled] {
  background-color: #d8dcde !important;
  border-color: #d8dcde !important;
  color: #fff !important;
  opacity: 1;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.btn.btn-primary {
  background-color: #2f3941;
  border-color: #2f3941;
  color: #fff;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

.btn.btn-primary:hover {
  background-color: #444;
  border-color: #444;
  color: #f8f9f9;
}

.btn.btn-primary:active,
.btn.btn-primary.active {
  background-color: #2f3941;
  border-color: #2f3941;
  color: #c2c8cc;
}

.btn.btn-primary {
  border-color: #2f3941;
}

.btn.rating > * {
  vertical-align: bottom;
}

.btn.rating {
  background-repeat: no-repeat;
}

.btn.rating .short {
  display: none;
}

.btn.rating .long {
  display: inline-block;
  padding-left: 0.3rem;
}

.btn.rating .icon {
  width: 1.7rem;
  height: 2rem;
}

.icon {
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.btn.rating.good {
  border-color: #1f73b7;
  margin-right: 5px;
}

.btn.rating.good .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-thumb-up-grey.svg');
}

.btn.rating.good:hover {
  color: #1f73b7;
}

.btn.rating.good:hover .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-thumb-up-blue.svg');
}

input[type='radio']:checked + label > .btn.rating.good,
.btn.rating.good:active {
  background-color: #1f73b7;
  border-color: #1f73b7;
  color: #fff;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

input[type='radio']:checked + label > .btn.rating.good .icon,
.btn.rating.good:active .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-thumb-up-white.svg');
}

.btn.rating.bad {
  border-color: #bf3026;
}

.btn.rating.bad .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-thumb-down-grey.svg');
}

.btn.rating.bad:hover {
  color: #bf3026;
}

.btn.rating.bad:hover .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-thumb-down-red.svg');
}

input[type='radio']:checked + label > .btn.rating.bad,
.btn.rating.bad:active {
  background-color: #bf3026;
  border-color: #bf3026;
  color: #fff;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

input[type='radio']:checked + label > .btn.rating.bad .icon,
.btn.rating.poor:active .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-thumb-down-white.svg');
}

strong {
  font-weight: 600;
}

label {
  display: block;
  margin-bottom: 1rem;
  color: #2f3941;
  font-weight: 600;
}

select,
textarea,
input {
  border: 1px solid #d8dcde;
  outline: 0;
  box-shadow: none;
  margin-bottom: 2rem;
}

select:focus,
textarea:focus,
input:focus {
  border-color: #78a300;
}

select:disabled,
textarea:disabled,
input:disabled {
  background-color: #f8f9f9;
}

textarea {
  width: 98%;
  width: calc(100% - 1.8rem);
  border: 1px solid #d8dcde;
  border-radius: 4px;
  padding: 0.8rem;
  resize: vertical;
}

input[name='satisfaction_rating'] {
  display: none;
}

select#ticket_satisfaction_reason_code {
  height: 3.4rem;
}

.alert > * {
  vertical-align: middle;
}

.alert {
  text-align: center;
  padding: 1.5rem 0;
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
  -moz-transition: opacity 0.25s ease-in-out;
  -webkit-transition: opacity 0.25s ease-in-out;
}

@media only screen and (max-width: 500px) {
  .alert {
    padding: 1.5rem 2rem 1.5rem 2.2rem;
  }
}

.alert .icon {
  width: 2rem;
  height: 2rem;
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-warning-tick.svg');
}

.alert .message {
  display: inline-block;
  max-width: calc(830px - 3rem);
}

@media only screen and (max-width: 500px) {
  .alert .message {
    max-width: calc(100% - 3rem);
  }
}

.alert.info {
  background: #ecf4f8;
  border-color: #abd0e3;
}

.alert.info .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-warning-tick.svg');
}

.alert.warning {
  background: #ffeded;
  border-color: #f7cbcb;
}

.alert.warning .icon {
  background-image: url('https://static.zdassets.com/classic/images/csat/ic-warning-exclamation.svg');
}

.alert.hidden {
  opacity: 0;
}

.container {
  width: 830px;
  margin: auto;
}

@media only screen and (max-width: 500px) {
  .container {
    width: 100%;
    margin: 0;
  }
}

#ticket-details {
  margin-bottom: 4rem;
}

@media only screen and (max-width: 500px) {
  #ticket-details {
    background: #fff;
    border-bottom: 1px solid #d8dcde;
    padding: 2rem;
    margin-bottom: 2rem;
  }
}

#ticket-details #logo {
  margin-bottom: 3rem;
  height: 3.5rem;
}

@media only screen and (max-width: 500px) {
  #ticket-details #logo {
    margin-bottom: 2rem;
  }
}

#ticket-details .ticket-title {
  font-size: 1.6rem;
  width: 550px;
  margin: 0;
  line-height: 2.4rem;
  position: relative;
  bottom: 2.4rem;
  display: inline-block;
}

@media only screen and (max-width: 500px) {
  #ticket-details .ticket-title {
    width: 100%;
    margin: 2rem 0.8rem 0 0.8rem;
    bottom: 1.4rem;
    font-size: 1.3rem;
    line-height: 1.8rem;
    text-align: left;
    text-align: start;
  }
}

#ticket-details .assignee {
  width: 276px;
  display: inline-block;
  text-align: right;
  text-align: end;
}

@media only screen and (max-width: 500px) {
  #ticket-details .assignee {
    width: 100%;
    display: block;
    text-align: left;
    text-align: start;
  }
}

#ticket-details .assignee .assignee-meta {
  width: 222px;
  float: left;
}

@media only screen and (max-width: 500px) {
  #ticket-details .assignee .assignee-meta {
    width: auto;
    float: none;
  }
}

#ticket-details .assignee .assignee-meta .assignee-name {
  font-size: 1.5rem;
  line-height: 1.8rem;
  margin-left: 5px;
}

@media only screen and (max-width: 500px) {
  #ticket-details .assignee .assignee-meta .assignee-name {
    font-size: 1.3rem;
    line-height: 1.8rem;
    margin-left: 4rem;
  }
}

#ticket-details .assignee .assignee-meta .assignee-title {
  color: #68737d;
  margin-left: 5px;
}

@media only screen and (max-width: 500px) {
  #ticket-details .assignee .assignee-meta .assignee-title {
    margin-left: 4rem;
  }
}

#ticket-details .assignee .assignee-avatar {
  position: relative;
  bottom: 5px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #d8dcde;
  float: right;
}

@media only screen and (max-width: 500px) {
  #ticket-details .assignee .assignee-avatar {
    margin: 0.5rem 0.8rem;
    float: left;
  }
}

#ticket-details .assignee .assignee-avatar.rtl {
  float: left;
}

@media only screen and (max-width: 500px) {
  #ticket-details .assignee .assignee-avatar.rtl {
    float: right;
  }
}

.section {
  background: #fff;
  border: 1px solid #d8dcde;
  padding: 3rem;
  margin-bottom: 2rem;
  border-radius: 5px;
}

@media only screen and (max-width: 500px) {
  .section {
    border-radius: 0;
    padding: 2rem;
    border-top: 1px solid #f8f9f9;
  }
}

@media only screen and (max-width: 500px) {
  #rating-form #ticket_satisfaction_reason_code {
    width: 100%;
  }
  #rating-form .btn.submit {
    width: 100%;
    height: 3.8rem;
  }
}

#rating-form #satisfaction-rating-buttons {
  margin-bottom: 2rem;
}

#rating-form #satisfaction-rating-buttons label {
  display: inline;
}

@media only screen and (max-width: 500px) {
  #rating-form #satisfaction-rating-buttons label {
    display: block;
  }
  #rating-form #satisfaction-rating-buttons .btn.rating {
    width: 100%;
  }
  #rating-form #satisfaction-rating-buttons .btn.rating .long {
    display: none;
  }
  #rating-form #satisfaction-rating-buttons .btn.rating .short {
    display: inline-block;
  }
}

#rating-form {
  text-align: left;
}

#rating-form #rating-form-actions {
  text-align: right;
  text-align: end;
}

#ticket-summary .requester-meta .requester-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #d8dcde;
  position: absolute;
  float: left;
}

@media only screen and (max-width: 500px) {
  #ticket-summary .requester-meta .requester-avatar {
    float: left;
    width: 50px;
    height: 50px;
    margin: 0.3rem 0;
  }
}

#ticket-summary .requester-meta .requester-name {
  margin-left: 8rem;
  margin-right: 8rem;
  font-size: 1.5rem;
  padding: 0.4rem 0;
}

@media only screen and (max-width: 500px) {
  #ticket-summary .requester-meta .requester-name {
    margin-left: 5rem;
    margin-right: 5rem;
  }
}

#ticket-summary .requester-meta .requester-comment-date {
  display: inline;
  margin-left: 8rem;
  margin-right: 8rem;
}

@media only screen and (max-width: 500px) {
  #ticket-summary .requester-meta .requester-comment-date {
    color: #68737d;
    margin-left: 5rem;
    margin-right: 5rem;
  }
}

#ticket-summary .timestamp {
  color: #68737d;
  padding: 0.5rem 0;
}

#ticket-summary .requester-comment {
  margin-left: 8rem;
  margin-right: 8rem;
}

@media only screen and (max-width: 500px) {
  #ticket-summary .requester-comment {
    margin-left: 0;
    margin-right: 0;
  }
}
</style>
